import { defineStore } from 'pinia';
import { ref, computed } from "vue"
import { getToken } from '@/utilities/cookies';
import accountService from "@/services/accountService";

export const useUserStore = defineStore('user-store', () => {
    const token = getToken();
    const customerCode = ref(null);
    const userDetails = ref(null);
    const userRoles = ref(null);
    const userLatitude = ref(null);
    const userLongitude = ref(null);

    const getUserDetails = async () => {
        try {
            const res = await accountService.fetchUserDetails(token);
            if (res.success) {
                userDetails.value = res.data;
                userLatitude.value = res.data?.Latitude || null;
                userLongitude.value = res.data?.Longitude || null;
                sessionStorage.setItem('rh_user_details', JSON.stringify(res.data));
            } else {
                throw new Error(res.error);
            }
            // @TODO For hotfix 111823 will revisit this logic to optimize user details retrieval and avoid unnecessary API calls. 
            // let userDetailsData = null;
            // userDetailsData = JSON.parse(sessionStorage.getItem('rh_user_details'));
            // if ( userDetailsData ) {
            //     userDetails.value = userDetailsData;
            //     userLatitude.value = userDetailsData?.Latitude || null;
            //     userLongitude.value = userDetailsData?.Longitude || null;
            // } else {
            //     const res = await accountService.fetchUserDetails(token);
            //     if (res.success) {
            //         userDetails.value = res.data;
            //         userLatitude.value = res.data?.Latitude || null;
            //         userLongitude.value = res.data?.Longitude || null;
            //         sessionStorage.setItem('rh_user_details', JSON.stringify(res.data));
            //     } else {
            //         throw new Error(res.error);
            //     }
            // }
            userRoles.value = userDetails.value?.UserRoles ? userDetails.value.UserRoles.split(',') : [];
            customerCode.value = userDetails.value?.CustomerDetail?.CustomerCode || userDetails.value?.CompanyId || null;
        } catch (err) {
            console.error('Error fetching user details:', err);
        }
    };
    getUserDetails();

    const customerRoles = {
        OWNER_EXECUTIVE: 1,
        SALES_ESTIMATOR: 2,
        PROJECT_MANAGER: 3,
        BACK_OFFICE: 4
    };

    const isOwnerExecutive = computed(() => userDetails.value?.CustomerRole === customerRoles.OWNER_EXECUTIVE);
    const isSalesEstimator = computed(() => userDetails.value?.CustomerRole === customerRoles.SALES_ESTIMATOR);
    const isProjectManager = computed(() => userDetails.value?.CustomerRole === customerRoles.PROJECT_MANAGER);
    const isBackOffice = computed(() => userDetails.value?.CustomerRole === customerRoles.BACK_OFFICE);
    
    // ===== COMPUTED (Permission Getters) =====
    const hasOrderingViewerPermission = computed(() => 
        userRoles.value?.includes('OrderingViewer') ?? false
    );
    
    const hasPriceViewerPermission = computed(() => 
        userRoles.value?.includes('PriceViewer') ?? false
    );
    
    const hasTrendsViewerPermission = computed(() => 
        userRoles.value?.includes('TrendsViewer') ?? false
    );
    
    const hasInvoiceViewerPermission = computed(() => 
        userRoles.value?.includes('InvoiceViewer') ?? false
    );

    const hasProductCatalogPreviewPermission = computed(() => 
        userRoles.value?.includes('ProductCatalogPreview') ?? false
    );
    
    const hasOnlineOrderingPermission = computed(() => 
        userRoles.value?.includes('OnlineOrdering') ?? false
    );
    
    const canSelectOtherUser = computed(() => {
        const role = userDetails.value?.CustomerRole;
        if (role === undefined || role === null) return false;
        return role === customerRoles.OWNER_EXECUTIVE || role === customerRoles.BACK_OFFICE;
    });
    
    return { 
        // State
        userDetails,
        userRoles,
        customerCode,
        userLatitude,
        userLongitude,
        customerRoles,
        // Actions
        getUserDetails,
        // Computed (Permissions)
        hasOrderingViewerPermission,
        hasPriceViewerPermission,
        hasTrendsViewerPermission,
        hasInvoiceViewerPermission,
        hasProductCatalogPreviewPermission,
        hasOnlineOrderingPermission,
        canSelectOtherUser,

        isOwnerExecutive,
        isSalesEstimator,
        isProjectManager,
        isBackOffice
    }
});
